window.$ = window.jQuery = require('jquery');

window.flexslider = require('flexslider');

// Hamburger Menu
var hamburger = document.querySelector(".hamburger");
var nav = document.querySelector(".nav-primary");
hamburger.addEventListener("click", function () {
  hamburger.classList.toggle("is-active");
  nav.classList.toggle("is-active");
});


// Technical specifications
var techSpecButton = document.querySelector('.tech-spec .toggle');
if (techSpecButton !== null) {
  var techSpecData = document.querySelector('.tech-spec__data');
  techSpecButton.addEventListener("click", function (event) {
    event.preventDefault();
    techSpecData.classList.toggle("is-active");
  });
}

// Product enquiries
var productEnquiryButton = document.querySelector('.btn--enquire');
if (productEnquiryButton !== null) {
  var productModal = document.querySelector('.enquiry-modal');
  var productModalClose = document.querySelector('.enquiry-modal__holder > .close');

  productEnquiryButton.addEventListener("click", function (event) {
    event.preventDefault();
    productModal.classList.remove("hidden");
  });
  productModalClose.addEventListener("click", function () {
    productModal.classList.add("hidden");
  });


}
